"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestSmartReading = exports.getLatestConfirmedReadings = void 0;
var date_fns_1 = require("date-fns");
var mostRecentFirst = function (a, b) {
    return (0, date_fns_1.isBefore)(a.readingDateTime, b.readingDateTime) ? 1 : -1;
};
var getLatestConfirmedReadings = function (readings) {
    return readings
        .sort(mostRecentFirst)
        .find(function (reading) {
        return reading.readingType !== 'CorrectionReadEstimate' &&
            reading.readingType !== 'EstimatedReading' &&
            reading.readingType !== 'MigrationReadingEstimated';
    });
};
exports.getLatestConfirmedReadings = getLatestConfirmedReadings;
var getLatestSmartReading = function (readings) {
    return readings
        .sort(mostRecentFirst)
        .find(function (reading) { return reading.readingType === 'SmartReading'; });
};
exports.getLatestSmartReading = getLatestSmartReading;
